/** Komparátor pre `Array.sort` ktorý vzostupne zoradí objekty podľa property `poradie`. */
export const poradieComparator = (a: any, b: any) => (a.poradie > b.poradie ? 1 : -1)
